module.exports = __webpack_public_path__ + "static/media/orsak.5b644460.mp3";